import styled from "styled-components";
import {size} from "../../helpers/breakpoints";

export const Container = styled.div`
  width: 75px;
  height: 100vh;
  transition: .3s;
  background-color: var(--accent-color);
  overflow-y: auto;
  
  @media only screen and (max-width: ${size.xl}) {
    position: fixed;
    bottom: 0;
    width: 100vw;
    z-index: 20;
    height: 60px;
    padding: 0 2rem;
  }
`;

export const LogoIconContainer = styled.div`
  margin: 2rem 0;
  color: #FFF;
`;

export const LogoIcon = styled.i`
  &::before {
    font-size: 30px;
  }
`;

export const IconContainer = styled.div`
  flex: 1;
`;

export const Icon = styled.i`
  color: #d7d7d7;
  opacity: .8;
  transition: .2s;

  &::before {
    font-size: 25px;
  }
`;
